import React,{ useState, useEffect, useRef } from 'react';

import './Menu.less';

const Menu = ({menuData, selectMenu, setSelectMenu, padding}) =>{
  const initRef = useRef(null)
  const [selectW, setSelectW] = useState(0)
  const [leftPosition, setLeftPosition] = useState(0)

  

  useEffect(()=>{
    if(initRef.current){
      console.log(initRef.current.offsetWidth)
      // const clickedElement = initRef.current.target
      setSelectW(()=> initRef.current.offsetWidth)
      setLeftPosition(()=> initRef.current.offsetLeft)
    }
    console.log(selectMenu)
  },[selectMenu])
  


  return (
    <div className="Menu-box" style={padding? {padding: padding}:{}}>
      <div className="Menu-list">
        {menuData.map((e,i)=>{
          return (
            <div 
              key={i} 
              ref={e.label === selectMenu.label? initRef:null}
              className="Menu-item" 
              style={e.label === selectMenu.label? {color:'#000'}:{}}
              onClick={()=> setSelectMenu(()=> e)}
            >
              {e.label}
            </div>
          )
        })}

        <div className="slider" style={{width: selectW, left: leftPosition}}></div>
      </div>
    </div>
  )
}

export default Menu